<template>
  <div id="dashboard-certificate" v-if="certificate.data != null" v-loading="certificate.loading">

      <el-row :gutter="20">
        <el-col :span="24">
          <div class="statistics-container">

            <div class="overview-table-header">
              <h3>{{$t('components.dashboard.certificate.digitalCertificate')}}</h3>
              <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
                <el-button icon="fas fa-download" size="mini" @click="downloadReport" disabled></el-button>
              </el-tooltip>
            </div>

            <el-table :data="certificate.data.certificateAnaliystics" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.certificate.certificate')" min-width="180">
                <template slot-scope="scope">
                  <span><b>{{ scope.row.title }}</b></span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.certificate.submitted')" width="100">
                <template slot-scope="scope">
                  <span><b>{{ scope.row.sent }}</b></span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.certificate.forwarded')" width="100">
                <template slot-scope="scope">
                  <span><b>{{ scope.row.delivered }}</b></span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.certificate.readed')" width="100">
                <template slot-scope="scope">
                  <span><b>{{ scope.row.read }}</b></span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.certificate.queue')" width="100">
                <template slot-scope="scope">
                  <span><b>{{ scope.row.queue }}</b></span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.certificate.error')" width="100">
                <template slot-scope="scope">
                  <span><b>{{ scope.row.error }}</b></span>
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <span>{{$t('components.dashboard.certificate.certificateExpiry')}}<b>{{  $moment(props.row.expireDate).format("DD MM YYTHH:mm")}}</b></span>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </el-col>
      </el-row>


  </div>
</template>

<script>
import axios from "axios"
export default {
  components: {  },
  name: 'Certificate',
  data() {
    return {
      axios,
      chart :null,
    };
  },
  methods: {
    downloadReport() {
      axios.post("report/generalstatistics", {}).then(res => {
        this.$message.success(res.data.alert.message)
      })
    },

  },

  async mounted() {
    if(this.certificate.data == null)
    {
      await this.$store.dispatch('getCertificate', {});
    } 
  },

  computed: {
    certificate() {
      return this.$store.getters.getDashboardCertificate;
    },
  },

  beforeDestroy() { },

  watch: { },

};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Certificate.vue